/* eslint-disable @typescript-eslint/no-loss-of-precision */
import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenFieldProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { SafetyLimit } from 'app/area/codetable/item/types-store';
import { getSafetyLimitValidation } from './safety-limit-validation';

export interface SafetyLimitMinValueProps extends ScreenFieldProps {
  value: number;
  onChange: (value: number) => void;
  safetyLimit: SafetyLimit;
  required?: boolean;
  validation: { [key: string]: any };
}

export const SafetyLimitMinValue = ({ onChange, translation, readOnlyConfig, validation, value, safetyLimit, required }:
  SafetyLimitMinValueProps) => {

  const { fieldValidation, serverValidation } = getSafetyLimitValidation(ScreenPicker.minValue, safetyLimit, validation);

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];
  const isRequired = !readOnly && required;

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId="safety_limit_min_value"
      readOnly={readOnly}
      label={translation ? { text: translation.min_value } : undefined}
      value={value}
      onChange={onChange}
      useThousand=" "
      maxValue={999999999999999.999999999999999}
      maxDecimals={15}
      validation={(isRequired && fieldValidation) || serverValidation}
      required={isRequired}
      textInvalidRangeError={translation.min_max_value_error_message}
    />
  </div>;
};
